import * as React from 'react';

const styles = require('../CCPA.scss');

interface Props {
    confirmationText: string;
    onConfirm: () => void;
}

export default class CCPASubmissionSuccess extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div className={styles.contentContainer}>
                <div className={styles.mainText}>{this.props.confirmationText}</div>
                <div>
                    <button className='nx-button nx-button--primary' onClick={this.props.onConfirm}>
                        OK
                    </button>
                </div>
            </div>
        );
    }
}
